// import '@babel/polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { legoPerf } from '@zz-common/lego'
import './skeleton'
import URL from '@/lib/url'

try {
  const isPreRender = URL.getParam('isPreRender') || ''
  if (!isPreRender) {
    if (!(location.href.indexOf('zz-platform-pages/my-attention') > -1)) {
      legoPerf({
        openMeasure: true
      })
    }
  }
} catch (err) {
  console.warn(err)
}

window.onload = function () {
  // eslint-disable-next-line no-unused-expressions
  import('./entry')
}
